import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Modal,
    Input,
    setParamsFilter,
    Card,
    Select,
    Switch,
    Textarea,
    Radio,
    InputNumber
} from "../../../ui/ot";
import { useCRUDController } from "../../../ui/classify_structure/CRUDController"
import { useTranslation } from "react-i18next";
const SerialFrequencyManagement = (
    permission_level = null, 
) => {
    return (
        <Row>
            <Col span={24}>
                <SerialFrequencyManagementTable keyPrefix={'cataloging.serial_frequency_management'} permission_level={permission_level} />
            </Col>
        </Row>
    )
}
const SerialFrequencyManagementTable = ({
    rowKey = "id",
    keyPrefix = 'cataloging.serial_frequency_management',
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null);
    const columns = [
        {
            title: t('description'),
            dataIndex: "description",
            key: "description",

        },
        {
            title: t('unit'),
            dataIndex: "unit",
            key: "unit",
        },
        {
            title: t('issues_per_unit'),
            dataIndex: "issuesperunit",
            key: "issuesperunit",
           

        },
        {
            title: t('units_per_issue'),
            dataIndex: "unitsperissue",
            key: "unitsperissue",
        },
        {
            title: t('display_order'),
            dataIndex: "displayorder",
            key: "displayorder",
        },
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[rowKey]
                );
                selectRow = selectRow.filter(
                    (row) => row?.[rowKey] !== record?.[rowKey]
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const {

        getData,
        postData,
        patchData,
        deleteData,
    } = useCRUDController({
        apiRoute: "/koha/serial/periodicity",
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ProTableOt
                    formMode={true}
                    rowKey={"id"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return getData({
                            ...newParams,
                        });
                    }}
                    toolBarRender={() => {
                        return [];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<SerialFrequencyManagementForm />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                    }
                                })
                                postData(newData)
                            },
                            patchData: patchData,
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={permission_level?.permission_level === 1 ? true : false}
                    propsPatchProcess={(record) => {
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={permission_level?.permission_level === 1 ? true : false}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost={permission_level?.permission_level === 1 ? true : false}
                    propsPostOnBefore
                    initialValues={{}}
                    propsWidth={800}
                />
            </Col>
        </Row>
    );
};

const SerialFrequencyManagementForm = (
    {
        keyPrefix = 'cataloging.serial_frequency_management',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },
        propsOnValuesChange = () => { }
    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const { t } = useTranslation('translation', { keyPrefix })
    const setDataInitialization = () => {

    };
    const onFinish = (values) => {
        values.collection_code = values.collection_code === "0" ? null : values.collection_code
        values.shelving_control_number = values.shelving_control_number ?? null
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {

    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );

}
const FormItemComponent = ({ keyPrefix, field, initialValues = {}, options }) => {
    const { t } = useTranslation('translation', { keyPrefix })
    function getValueByPath(obj, path) {
        const keys = path.split('.');  
        return keys.reduce((acc, key) => {
             
            if (acc && !isNaN(key)) {
                key = Number(key);  
            }
            return acc ? acc[key] : undefined;  
        }, obj);
    }
    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'id']}
                            fieldKey={[field?.fieldKey ?? '', 'id'].join('.')}
                            hidden={true}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`description`)}
                            name={[field?.name ?? '', 'description']}
                            fieldKey={[field?.fieldKey ?? '', 'description'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`unit`)}
                            name={[field?.name ?? '', 'unit']}
                            fieldKey={[field?.fieldKey ?? '', 'unit'].join('.')}
                        >
                            <Select options={[
                                { label: "天", value: "day" },
                                { label: "星期", value: "week" },
                                { label: "月", value: "month" },
                                { label: "年", value: "year" }
                            ]} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[4, 4]} justify={"center"}>
                            <Col>
                                <Typography.Title level={4}>
                                    {t('note_one_field_must_be_one')}
                                </Typography.Title>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`issues_per_unit`)}
                            name={[field?.name ?? '', 'issuesperunit']}
                            fieldKey={[field?.fieldKey ?? '', 'issuesperunit'].join('.')}
                            rules={[
                                {
                                    required: true,
                                    message: t('please_enter'),
                                    validate: (value, formValues) => {
                                        let temp = [field?.name ?? '', 'unitsperissue'].join('.')
                                        let unitsperissue = getValueByPath(formValues, temp)
                                        return (parseInt(value) === 1 || parseInt(unitsperissue) === 1) || t('please_enter')
                                    }
                                }
                            ]}
                        >
                            <InputNumber max={9999} />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`units_per_issue`)}
                            name={[field?.name ?? '', 'unitsperissue']}
                            fieldKey={[field?.fieldKey ?? '', 'unitsperissue'].join('.')}
                            rules={[{
                                required: true,
                                message: t('please_enter'),
                                validate: (value, formValues) => {
                                    let temp = [field?.name ?? '', 'issuesperunit'].join('.')
                                    let issuesperunit = getValueByPath(formValues, temp)
                                    return (parseInt(value) === 1 || parseInt(issuesperunit) === 1) || t('please_enter')
                                }
                            }]}
                        >
                            <InputNumber max={9999} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`display_order`)}
                            name={[field?.name ?? '', 'displayorder']}
                            fieldKey={[field?.fieldKey ?? '', 'displayorder'].join('.')}
                        >
                            <InputNumber max={9999} />
                        </Form.Item>
                    </Col>

                </Row>
            </Col>

        </Row>
    );
};

export default SerialFrequencyManagement
export { SerialFrequencyManagementTable, SerialFrequencyManagementForm }
